import { module } from "modujs";
import uploadFileMixin from "../vue-mixins/uploadFileMixin";
import formMixin from "../vue-mixins/formMixin";

const { required, maxLength, email, url } = window.validators;
const formProperties = {
    firstName: {
        required,
    },
    lastName: {
        required,
    },
    email: {
        required,
        email,
    },
    region: {
        required,
    },
    expertise: {
        required,
    },
    role: {
        required,
    },
    address: {
        // required,
    },
    city: {
        // required,
    },
    organisation: {
    },
    organisationUrl: {
        url
    },
    postalCode: {
        // required,
    },
    facebook: {
        url
    },
    twitter: {
        url
    },
    linkedIn: {
        url
    },
    instagram: {
        url
    },
    biography: {
    },
};

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // Initial values are used to prefill the form.
        this.initialValues = JSON.parse(this.getData("values"));

        this.formType = this.getData("type");

        if (this.formType !== "user" && this.formType !== "ambassador") {
            console.error("Invalid form type");
        }

        this.validProperties = undefined;
        this.propertiesValidation = undefined;

        // Define the available properties in the form
        this.assetValidProperties();

        // Init vue
        this.initVue();
    }

    /**
     * Asset existing properties in the given form
     */
    assetValidProperties() {
        this.validProperties = {
            submitStatus: "",
        };
        this.propertiesValidation = {};

        for (let ident in formProperties) {
            if (this.el.querySelector("[name=" + ident + "]")) {
                this.propertiesValidation[ident] = formProperties[ident];
                this.validProperties[ident] = "";
            }
        }
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default);

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el,

            delimiters: ["${", "}"],

            mixins: [uploadFileMixin, formMixin],

            data: () => {
                return {
                    picture: {},
                    ...this.validProperties,
                };
            },

            validations: this.propertiesValidation,

            created() {
                this.moduleInstance = moduleInstance;
                // Set initial values
                this.moduleInstance.initialValues &&
                    this.setInitialValues(this.moduleInstance.initialValues);
            },

            methods: {
                // submit() {
                //     this.$v.$touch();
                //
                //     // Scroll to invalid field
                //     if (this.$v.$invalid) {
                //         this.$nextTick(() => {
                //             const getInvalidFields = this.$el.querySelectorAll('.c-form_item.is-invalid')
                //             if (getInvalidFields.length) {
                //                 this.moduleInstance && this.moduleInstance.call('scrollTo', [getInvalidFields[0]], 'Scroll')
                //             }
                //         })
                //         return
                //     }
                //
                //     // Call Ajax
                //     const myPromise = new Promise((resolve) => {
                //         // Pending status
                //         this.submitStatus = "pending";
                //
                //         // Resolve
                //         setTimeout(() => {
                //             resolve(false)
                //         }, 2000)
                //     })
                //
                //     myPromise.then((response) => {
                //         // If succeed
                //         if (response) {
                //             this.submitStatus = "error"
                //             let redirectUrl = '/feedback-generic'
                //             //this.moduleInstance.call('goTo', {'url': redirectUrl}, 'Load')
                //
                //         // If error
                //         } else {
                //             this.submitStatus = "error";
                //             this.moduleInstance && this.moduleInstance.call('scrollTo', [this.$el], 'Scroll')
                //         }
                //     })
                // },

                setInitialValues(values) {
                    Object.assign(this, values);
                },
                setPictureValues(name, src) {
                    // this.user.picture.name = name
                    // this.user.picture.src = src
                    // this.picture.name = name;
                    // this.picture.src = src;

                    this.picture = Object.assign({}, this.picture, { name, src })
                },
            },
        });
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
